import { useEffect } from "react";

import { prefetchFatherNavigationData } from "./api/client";
import { ActivationPage } from "./pages/ActivationPage";
import { ContactsPage } from "./pages/ContactsPage";
import { FavoritesPage } from "./pages/FavoritesPage";
import { HelpPage } from "./pages/HelpPage";
import { HomePage } from "./pages/HomePage";
import { MediaPage } from "./pages/MediaPage";
import { MessagesPage } from "./pages/MessagesPage";
import { PeacePage } from "./pages/PeacePage";
import { RadioPage } from "./pages/RadioPage";
import { RecentPage } from "./pages/RecentPage";
import { SeriesPage } from "./pages/SeriesPage";
import { StartupPage } from "./pages/StartupPage";
import { TodayPage } from "./pages/TodayPage";
import { useNavigationStore } from "./stores/navigationStore";
import { useSessionStore } from "./stores/sessionStore";

function CurrentRoute() {
  const route = useNavigationStore((state) => state.route);

  switch (route.name) {
    case "media":
      return <MediaPage />;
    case "series":
      return <SeriesPage seriesId={route.seriesId} />;
    case "recent":
      return <RecentPage />;
    case "favorites":
      return <FavoritesPage />;
    case "messages":
      return <MessagesPage />;
    case "radio":
      return <RadioPage />;
    case "contacts":
      return <ContactsPage />;
    case "today":
      return <TodayPage />;
    case "peace":
      return <PeacePage />;
    case "help":
      return <HelpPage />;
    case "home":
    default:
      return <HomePage />;
  }
}

export function App() {
  const activated = useSessionStore((state) => state.activated);
  const loading = useSessionStore((state) => state.loading);
  const offlineMainMenuShell = useSessionStore(
    (state) => state.offlineMainMenuShell,
  );
  const init = useSessionStore((state) => state.init);

  useEffect(() => {
    void init();
  }, [init]);

  useEffect(() => {
    if (activated && !offlineMainMenuShell) {
      prefetchFatherNavigationData();
    }
  }, [activated, offlineMainMenuShell]);

  if (loading) {
    return <StartupPage />;
  }

  if (!activated) {
    return <ActivationPage />;
  }

  return <CurrentRoute />;
}
